import React from 'react';
import { ActivityList } from 'app/components/district/common/ActivityStyles';
import TransferActivity from 'app/components/district/transfers/TransferActivity';
export default function TransferList(_ref) {
  let {
    data
  } = _ref;
  const transfers = data.pages.map(page => page.data).flat();
  return /*#__PURE__*/React.createElement(ActivityList, {
    "data-sentry-element": "ActivityList",
    "data-sentry-component": "TransferList",
    "data-sentry-source-file": "TransferList.tsx"
  }, transfers.map(transfer => /*#__PURE__*/React.createElement(TransferActivity, {
    key: transfer.getKey(),
    data: transfer
  })));
}